<template>
  <div>
    <div class="mb16" v-if="!doubleYAxis">
      <cx-check-box :value.sync="showSplitLineX">显示横向网格线</cx-check-box>
      <line-setting
        v-if="showSplitLineX"
        class="mt16"
        title="网格线设置"
        :lineName.sync="splitTypeX"
        :lineWidth.sync="splitWidthX"
        :lineColor.sync="splitColorX"
        suffix="px"
      />
    </div>
    <!-- 双Y轴默认修改第一条纵轴的设置 -->
    <div class="mb16" v-if="doubleYAxis">
      <cx-check-box :value.sync="showSplitLineX0">显示横向网格线</cx-check-box>
      <line-setting
          v-if="showSplitLineX0"
          class="mt16"
          title="网格线设置"
          :lineName.sync="splitTypeX0"
          :lineWidth.sync="splitWidthX0"
          :lineColor.sync="splitColorX0"
          suffix="px"
      />
    </div>
    <cx-check-box :value.sync="showSplitLineY">显示纵向网格线</cx-check-box>
    <line-setting
      v-if="showSplitLineY"
      class="mt16"
      title="网格线设置"
      :lineName.sync="splitTypeY"
      :lineWidth.sync="splitWidthY"
      :lineColor.sync="splitColorY"
      suffix="px"
    />
  </div>
</template>

<script>
import publicData from "./publicData"
export default {
  mixins: [publicData],
  props: {
    options: {
      type: Object
    },
    ids: {
      type: Object
    },
    doubleYAxis: {
      type: Boolean
    }
  },
  data() {
    return {
      this1: this
    }
  },
  computed: {
    chartOpt() {
      return this.options.chartOption
    },
    showSplitLineY: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "xAxis.splitLine.show", "xAxis.splitLine.show", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.xAxis.splitLine.show", false)
      }
    },
    showSplitLineX: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "yAxis.splitLine.show", "yAxis.splitLine.show", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.yAxis.splitLine.show", false)
      }
    },
    splitColorX: {
      get() {
        return this.hasProperty(this.chartOpt, "yAxis.splitLine.lineStyle.color")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.yAxis.splitLine.lineStyle.color", false)
      }
    },
    splitColorY: {
      get() {
        return this.hasProperty(this.chartOpt, "xAxis.splitLine.lineStyle.color")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.xAxis.splitLine.lineStyle.color", false)
      }
    },
    splitTypeX: {
      get() {
        return this.hasProperty(this.chartOpt, "yAxis.splitLine.lineStyle.type")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.yAxis.splitLine.lineStyle.type", false)
      }
    },
    splitTypeY: {
      get() {
        return this.hasProperty(this.chartOpt, "xAxis.splitLine.lineStyle.type")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.xAxis.splitLine.lineStyle.type", false)
      }
    },
    splitWidthX: {
      get() {
        return this.hasProperty(this.chartOpt, "yAxis.splitLine.lineStyle.width")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.yAxis.splitLine.lineStyle.width", false)
      }
    },
    splitWidthY: {
      get() {
        return this.hasProperty(this.chartOpt, "xAxis.splitLine.lineStyle.width")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.xAxis.splitLine.lineStyle.width", false)
      }
    },
    showSplitLineX0: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "yAxis.0.splitLine.show", "yAxis.0.splitLine.show", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.yAxis.0.splitLine.show", false)
      }
    },
    splitColorX0: {
      get() {
        return this.hasProperty(this.chartOpt, "yAxis.0.splitLine.lineStyle.color")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.yAxis.0.splitLine.lineStyle.color", false)
      }
    },
    splitTypeX0: {
      get() {
        return this.hasProperty(this.chartOpt, "yAxis.0.splitLine.lineStyle.type")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.yAxis.0.splitLine.lineStyle.type", false)
      }
    },
    splitWidthX0: {
      get() {
        return this.hasProperty(this.chartOpt, "yAxis.0.splitLine.lineStyle.width")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.yAxis.0.splitLine.lineStyle.width", false)
      }
    },
  }
}
</script>

<style scoped>
.toolbar .linestyle-select {
  margin-bottom: 0;
}
</style>
